$(document).ready(function() {
	function formatMoney(value) {
		const cents = (parseFloat(value) / 100).toFixed(2);
		const formattedValue = new Intl.NumberFormat('de-DE', {
			style: 'currency',
			currency: 'EUR'
		}).formatToParts(cents);
		
		const currencySymbol = formattedValue.find(part => part.type === 'currency');
		const formattedPrice = formattedValue
			.filter(part => part.type !== 'currency')
			.map(part => part.value)
			.join('');
		
		return `${currencySymbol.value}${formattedPrice}`;
	}
	$(document).on('click', '.js-grid-swatch .swiper-wrapper .swatch__button', function() {
		$(this).closest('.product-grid-item').find('.swatch__button').removeClass('active');
		$(this).addClass('active');
		const variantJson = JSON.parse($(this).closest('.product-grid-item').find('[type="application/json"]')[0].textContent)
		const curentVariantId = parseInt($(this).find('.swatch__label').attr('data-swatch-variant'));
		const curentVariantJson = variantJson.find(variant => variant.id == curentVariantId);
		const forminput = $(this).closest('.product-grid-item').find('.quick__add__form input[name="id"]');
		const formbutton = $(this).closest('.product-grid-item').find('.quick__add__form button[type="submit"]');
		const price = $(this).closest('.product-grid-item').find('.product-grid-item__price .price_of-product');
		forminput.val(curentVariantJson.id)
		formbutton.attr('data-product-id', curentVariantJson.id)
		const priceFormated = formatMoney(curentVariantJson.price);
		const compareAtPriceFormated = formatMoney(curentVariantJson.compare_at_price);
		if(curentVariantJson.available){
		    formbutton.removeAttr('disabled')
		}else{
		    formbutton.attr('disabled', 'disabled')
		}
		if(curentVariantJson.compare_at_price != null){
		    price[0].innerHTML = `${priceFormated,''} <s>${compareAtPriceFormated,''}<s/>`
		}else{
		    price[0].innerHTML = priceFormated;
		}
		if (curentVariantJson.featured_image != null) {
			const imageBlock = $(this).closest('.product-grid-item').find('.product__media.product__media--featured');
			imageBlock.attr('data-bgset', curentVariantJson.featured_image.src);
			imageBlock[0].style.backgroundImage = "url(" + curentVariantJson.featured_image.src + ")";
		} else {
			const imageBlock = $(this).closest('.product-grid-item').find('.product__media.product__media--featured');
			imageBlock.attr('data-bgset', imageBlock.attr('data-default-bgset'));
		}

	})
});